import { c as _c } from "react/compiler-runtime";
import { useToggle } from '@react-hookz/web/useToggle/index.js';
import type { PropsWithChildren, ElementType, CSSProperties } from 'react';
import { useElementOverflow } from '#cutils/hooks/useElementOverflow';
import styles from './ShowMore.module.scss';
type ShowMoreProps = PropsWithChildren<{
  as?: ElementType;
  minimizedHeight: CSSProperties['height'];
  className?: string;
  style?: CSSProperties;
}>;
export function ShowMore(t0) {
  const $ = _c(16);
  const {
    as: t1,
    children,
    className: t2,
    style,
    minimizedHeight
  } = t0;
  const As = t1 === undefined ? "div" : t1;
  const className = t2 === undefined ? "" : t2;
  const [isExpanded, setExpanded] = useToggle(false);
  const {
    ref,
    overflow
  } = useElementOverflow("vertical", !isExpanded);
  const t3 = `${styles.container} ${isExpanded ? styles.expanded : ""} ${className}`;
  let t4;
  if ($[0] !== minimizedHeight || $[1] !== style) {
    t4 = {
      ...style,
      height: minimizedHeight
    };
    $[0] = minimizedHeight;
    $[1] = style;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== As || $[4] !== children || $[5] !== ref || $[6] !== t3 || $[7] !== t4) {
    t5 = <As ref={ref} className={t3} style={t4}>{children}</As>;
    $[3] = As;
    $[4] = children;
    $[5] = ref;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== isExpanded || $[10] !== overflow || $[11] !== setExpanded) {
    t6 = (overflow || isExpanded) && <button className={`body1 ${styles.moreButton} button-link no-focus`} onClick={setExpanded}>{!isExpanded ? "mehr" : "weniger"}</button>;
    $[9] = isExpanded;
    $[10] = overflow;
    $[11] = setExpanded;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}